import { WidgetsStaffMain } from '@/widgets/staff';

export const PagesStaffMain = () => <WidgetsStaffMain />;
